<!-- eslint-disable max-len -->
<template>
  <div>
    <v-row no-gutters>
      <v-col
        :cols="12"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
        class="center-card mx-auto pt-3 py-3 pr-5 pl-5"
      >
        <v-card class="text-center" style="width: 100%;">
          <v-card-title class="title-bg">
            <v-row class="pt-3 pb-3 pr-3 pl-3">
              <div style="font-size: 20px;color: white;">
                ระบบการแจ้งเหตุจำเป็นที่ไม่อาจไปใช้สิทธิเลือกตั้งทางอิเล็กทรอนิกส์&nbsp;
              </div>
              <div style="font-size: 20px;color: white;">
                การเลือกตั้งสมาชิกสภาผู้แทนราษฎร
              </div>
            </v-row>
          </v-card-title>
          <v-row no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelinfo">
              ชื่อ
            </div>
          </v-row>
          <v-row no-gutters class="pr-5 pl-5 pt-2">
            <div class="labelmain">
              {{ descname }}
            </div>
          </v-row>
          <v-row no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelinfo">
              ประเภทการเลือกตั้ง
            </div>
          </v-row>
          <v-row no-gutters class="pr-5 pl-5 pt-2">
            <div class="labelmain">
              {{ desctype }}
            </div>
          </v-row>
          <v-row no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelinfo">
              วันที่เลือกตั้ง
            </div>
          </v-row>
          <v-row no-gutters class="pr-5 pl-5 pt-2">
            <div class="labelmain">
              {{ ifunc.monthFormat(desceledate) }}
            </div>
          </v-row>
          <v-row no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelinfo">
              สถานที่ที่มีสิทธิเลือกตั้ง
            </div>
          </v-row>
          <v-row v-show="descarea !== '*'" no-gutters class="pr-5 pl-5 pt-2">
            <div class="labelmain">
              {{ descarea }}
            </div>
          </v-row>
          <v-row v-show="endShow && !delEnd" no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelinfo">
              สาเหตุไม่ไปใช้สิทธิ
            </div>
          </v-row>
          <v-row v-show="endShow && !delEnd" no-gutters class="pr-5 pl-5 pt-2">
            <div class="labelmain">
              {{ causeFormat(cause) }}
            </div>
          </v-row>
          <v-row v-show="outmark !== 0" no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelinfo">
              สถานะการลงทะเบียน
            </div>
          </v-row>
          <v-row v-show="outmark !== 0" no-gutters class="pr-5 pl-5 pt-2">
            <div class="labelmain">
              {{ markFormat(outmark) }}
            </div>
          </v-row>
          <v-row v-show="outmark !== 0" no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelinfo">
              สถานที่ขอไปใช้สิทธิเลือกตั้ง
            </div>
          </v-row>
          <v-row v-show="outmark !== 0" no-gutters class="pr-5 pl-5 pt-2">
            <div class="labelmain">
              {{ outdesc }}
            </div>
          </v-row>
          <v-row v-show="endShow" no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelmain">
              สถานะ : <font color="orange">
                {{ cancelFormat(stadesc) }}
              </font>
            </div>
          </v-row>
          <v-row v-show="!endShow" no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelinfo">
              สาเหตุไม่ไปใช้สิทธิ
            </div>
          </v-row>
          <v-row v-show="!endShow && !disEdit" no-gutters class="pr-5 pl-5 pt-2">
            <v-select
              v-model="cause"
              :items="dropdown"
              item-value="value"
              item-text="text"
              dense
              placeholder="สาเหตุ"
              target="#dropdown-example"
            />
          </v-row>
          <v-row v-show="!endShow && !disEdit && cause === 6" no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelmain" style="text-align: left;font-size: 16px;">
              สาเหตุสุดวิสัย
            </div>
          </v-row>
          <v-row v-show="!endShow && !disEdit && cause === 6" no-gutters class="pr-5 pl-5 pt-2">
            <v-text-field
              v-model="causeclue"
              placeholder="สาเหตุสุดวิสัย"
              :maxlength="256"
            />
          </v-row>
          <v-row v-show="!endShow && disEdit" no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelmain">
              {{ causeFormat(cause) }} <font color="red">
                (ไม่สามารถเปลี่ยนสาเหตุไม่ไปใช้สิทธิได้เนื่องจากได้มีการแจ้งเหตุไปแล้ว)
              </font>
            </div>
          </v-row>
          <v-row v-show="updel && !endShow" no-gutters class="pr-5 pl-5 pt-2 mt-2">
            <div class="labelmain">
              สถานะ : <font color="orange">
                {{ stadesc }}
              </font>
            </div>
          </v-row>
          <v-row v-show="!endShow && !updel" no-gutters class="pr-5 pl-5 pt-2 py-4">
            <v-col :cols="12"
                   :sm="12"
                   :md="12"
                   :lg="12"
                   :xl="12"
            >
              <v-btn color="primary" style="font-size: 16px;width:100%;" @click="processClick(1)">
                <span class="material-icons">
                  save
                </span>
                <div style="font-size: 16px;font-weight: 500;">
                  บันทึกข้อมูล
                </div>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-show="!endShow && updel" no-gutters class="pr-5 pl-5 pt-2 py-4">
            <v-col :cols="12"
                   :sm="12"
                   :md="12"
                   :lg="6"
                   :xl="6"
            >
              <div class=" pt-2 pb-4">
                <v-btn color="primary" class="pr-2 pl-2" style="font-size: 16px; width:100%;" @click="processClick(2)">
                  <span class="material-icons">
                    edit
                  </span>
                  <div style="font-size: 16px;font-weight: 500;">
                    แก้ไขข้อมูลการลงทะเบียน
                  </div>
                </v-btn>
              </div>
            </v-col>
            <v-col :cols="12"
                   :sm="12"
                   :md="12"
                   :lg="6"
                   :xl="6"
            >
              <div class="pr-2 pl-2 pt-2 pb-4">
                <v-btn color="#F54051" style="font-size: 16px;width:100%;color: white;" @click="processClick(3)">
                  <span class="material-icons">
                    delete
                  </span>
                  <div style="font-size: 16px;font-weight: 500;">
                    ยกเลิกการลงทะเบียน
                  </div>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row v-show="endShow && !proTh" no-gutters class="pr-5 pl-5 pt-2 py-4">
            <v-col :cols="12"
                   :sm="12"
                   :md="12"
                   :lg="12"
                   :xl="12"
            >
              <v-btn color="primary" style="font-size: 16px;width:100%;" @click="back()">
                <span class="material-icons" style="padding-top: 5px;">
                  arrow_back
                </span>
                <div style="font-size: 16px;font-weight: 500;">
                  กลับ
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="isProcess"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text class="pt-3">
          กรุณารอสักครู่...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Swal from 'sweetalert2'
import moment from 'moment'
import api from '../../store/modules/api/api'
import func from '../../store/modules/functions/commonFunction'

export default {
  data() {
    return {
      isProcess: false,
      proTh: false,
      currentDate: 0,
      cause: '',
      updel: false,
      insert: false,
      endShow: false,
      delEnd: false,
      disEdit: false,
      descname: '',
      desctype: '',
      desceledate: '',
      descmark: '',
      descarea: '',
      stadesc: '',
      dropdown: [
        { text: '1.มีธุระจำเป็นเร่งด่วนที่ต้องเดินทางไปพื้นที่ห่างไกล', value: 1 },
        { text: '2.เจ็บป่วยและไม่สามารถเดินทางมาใช้สิทธิเลือกตั้งได้', value: 2 },
        { text: '3.เป็นคนพิการหรือทุพพลภาพ หรือผู้สูงอายุและไม่สามารถเดินทางมาใช้สิทธิเลือกตั้งได้', value: 3 },
        { text: '4.เดินทางออกนอกราชอาณาจักรและมิได้แจ้งความประสงค์ขอใช้สิทธิเลือกตั้งนอกราชอาณาจักร', value: 4 },
        { text: '5.มีถิ่นที่อยู่ห่างไกลจากที่เลือกตั้งเกินกว่า 100 กิโลเมตร', value: 5 },
        { text: '6.สาเหตุสุดวิสัยอื่น, เหตุอื่นที่คณะกรรมการการเลือกตั้งกำหนด', value: 6 }],
      outdesc: '',
      outmark: '',
      causeclue: '',
      isPortal: false,
      ifunc: func,
    }
  },
  computed: {
    ...mapState({
      eleData: state => state.regisStore,
      selData: state => state.dataStore,
      token: state => state.regisStore.token,
    }),
  },
  async created() {
    if (this.eleData.data.pid === 0) {
      await this.back()
      return 0
    }
    this.showInfo(this.selData.data.mark)
    let sysdate = ''
    sysdate = moment().locale('th').format('YYYY-MMDD')
    sysdate = ((Number(sysdate.split('-')[0]) + 543).toString() + sysdate.split('-')[1])
    this.currentDate = Number(sysdate)
    if (this.eleData.data.mark.split('#')[1] === '0') {
      this.insert = true
      if (this.cause !== 0) {
        this.disEdit = true
      }
    } else {
      this.updel = true
    }
    if (window.location.host === 'thportal-dev.bora.dopa.go.th:8080' || window.location.host === 'thportal.bora.dopa.go.th') {
      this.proTh = true
    }
  },
  methods: {
    ...mapActions({
      setEledate: 'regisStore/setEledate',
      resetData: 'regisStore/resetData',
    }),
    causeFormat(key) {
      let result = ''
      switch (key) {
        case 1:
          result = '1.มีธุระจำเป็นเร่งด่วนที่ต้องเดินทางไปพื้นที่ห่างไกล'
          break
        case 2:
          result = '2.เจ็บป่วยและไม่สามารถเดินทางมาใช้สิทธิเลือกตั้งได้'
          break
        case 3:
          result = '3.เป็นคนพิการหรือทุพพลภาพ หรือผู้สูงอายุและไม่สามารถเดินทางมาใช้สิทธิเลือกตั้งได้'
          break
        case 4:
          result = '4.เดินทางออกนอกราชอาณาจักรและมิได้แจ้งความประสงค์ขอใช้สิทธิเลือกตั้งนอกราชอาณาจักร'
          break
        case 5:
          result = '5.มีถิ่นที่อยู่ห่างไกลจากที่เลือกตั้งเกินกว่า 100 กิโลเมตร'
          break
        case 6:
          result = '6.สาเหตุสุดวิสัยอื่น, เหตุอื่นที่คณะกรรมการการเลือกตั้งกำหนด'
          break
        default:
          result = ''
      }
      return result
    },
    cancelFormat(text) {
      if (this.delEnd) {
        return 'ยกเลิกการแจ้งเหตุแล้ว'
      }
      return text
    },
    async processClick(par) {
      if (this.cause === 0 || this.cause === '') {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุสาเหตุไม่ไปใช้สิทธิ',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      if (this.cause === 6 && this.causeclue.trim() === '') {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุสาเหตุสาเหตุสุดวิสัย',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      const type = this.eleData.data.eledate.eletype
      const date = this.eleData.data.eledate.eledate
      const mark2 = this.eleData.data.mark.split('#')[0]
      if (this.currentDate === Number(date)) {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'ไม่อยู่ในช่วงเวลาของการแจ้งเหตุ',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      const data = this.setData(type, date, mark2, this.cause, this.causeclue)
      switch (par) {
        case 1:
          Swal.fire({
            title: 'ยืนยัน',
            text: 'ยืนยันการบันทึกข้อมูลแจ้งเหตุจำเป็นที่ไม่อาจไปใช้สิทธิเลือกตั้ง',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ปิด',
          }).then((result) => {
            if (result.value === true) {
              this.isProcess = true
              this.insertData(data)
            } else {
              this.isProcess = false
            }
          })
          break
        case 2:
          Swal.fire({
            title: 'ยืนยัน',
            text: 'ยืนยันแก้ไขการแจ้งเหตุจำเป็นที่ไม่อาจไปใช้สิทธิเลือกตั้ง',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ปิด',
          }).then((result) => {
            if (result.value === true) {
              this.isProcess = true
              this.updateData(data)
            } else {
              this.isProcess = false
            }
          })
          break
        case 3:
          Swal.fire({
            title: 'ยืนยัน',
            text: 'ยืนยันการยกเลิกแจ้งเหตุจำเป็นที่ไม่อาจไปใช้สิทธิเลือกตั้ง',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ปิด',
          }).then((result) => {
            if (result.value === true) {
              this.isProcess = true
              this.deleteData(data)
            } else {
              this.isProcess = false
            }
          })
          break
        default:
      }
    },
    setData(type, date, mark2, cause, causeclue) {
      let clue = causeclue
      if (!causeclue) clue = ' '
      return {
        eletype: type,
        eledate: date,
        mark2: Number(mark2),
        cause,
        cause_clue: clue,
      }
    },
    async insertData(data) {
      try {
        await api.apiinsert(this.token, data)
      } catch (error) {
        this.isProcess = false
        if (error.response.status === 404 && error.response.data.info !== undefined) {
          Swal.fire({
            icon: 'warning',
            title: 'แจ้งเตือน',
            text: error.response.data.info,
            confirmButtonText: 'ปิด',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'แจ้งเตือน',
            text: 'เกิดข้อผิดพลาดที่เครื่องเซิฟเวอร์',
            confirmButtonText: 'ปิด',
          })
        }
        return false
      }
      this.isProcess = false
      await Swal.fire({
        icon: 'success',
        title: 'แจ้งเหตุสำเร็จ',
        text: 'ตรวจสอบผลการพิจารณาในวันรุ่งขึ้น',
        confirmButtonText: 'ปิด',
      })
      await this.resetData()
      this.endShow = true
    },
    async updateData(data) {
      try {
        await api.apiupdate(this.token, data)
      } catch (error) {
        this.isProcess = false
        if (error.response.status === 404 && error.response.data.info !== undefined) {
          Swal.fire({
            icon: 'warning',
            title: 'แจ้งเตือน',
            text: error.response.data.info,
            confirmButtonText: 'ปิด',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'แจ้งเตือน',
            text: 'เกิดข้อผิดพลาดที่เครื่องเซิฟเวอร์',
            confirmButtonText: 'ปิด',
          })
        }
        return false
      }
      this.isProcess = false
      await Swal.fire({
        icon: 'success',
        title: 'แก้ไขข้อมูลการแจ้งเหตุสำเร็จ',
        text: 'ตรวจสอบผลการพิจารณาในวันรุ่งขึ้น',
        confirmButtonText: 'ปิด',
      })
      await this.resetData()
      this.endShow = true
    },
    async deleteData(data) {
      try {
        await api.apidelete(this.token, data.eletype, data.eledate, data.mark2, data.cause)
      } catch (error) {
        this.isProcess = false
        if (error.response.status === 404 && error.response.data.info !== undefined) {
          Swal.fire({
            icon: 'warning',
            title: 'แจ้งเตือน',
            text: error.response.data.info,
            confirmButtonText: 'ปิด',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'แจ้งเตือน',
            text: 'เกิดข้อผิดพลาดที่เครื่องเซิฟเวอร์',
            confirmButtonText: 'ปิด',
          })
        }
        return false
      }
      this.isProcess = false
      await Swal.fire({
        icon: 'success',
        title: 'ยกเลิกการแจ้งเหตุสำเร็จ',
        confirmButtonText: 'ปิด',
      })
      await this.resetData()
      this.endShow = true
      this.delEnd = true
    },
    back() {
      this.$router.push('/election/abscausess/')
    },
    showInfo(list) {
      this.descname = list[0].ntFname
      this.desctype = this.eleData.data.eledate.rcode
      this.desceledate = this.eleData.data.display
      // eslint-disable-next-line prefer-destructuring
      this.descmark = this.eleData.data.mark.split('#')[0]
      this.cause = list[0].ntCause
      if (this.cause === 6) this.causeclue = list[0].ntCauseClue
      this.stadesc = 'รอการอนุมัติ'
      this.outmark = list[0].ntMark1
      if (list[0].ntMark1 === 1 || list[0].ntMark1 === 2) {
        this.outdesc = list[0].ntMark1Desc
      } else {
        this.outdesc = ''
      }
      list.forEach(element => {
        if (element.ntMark2.toString() === this.descmark) {
          this.descarea = `เขตที่ ${element.ntEarea} หน่วยที่ ${element.ntEunit} ${element.ntDesp.replace('#', '')}`
        }
      })
    },
    markFormat(mark) {
      switch (mark) {
        case 0:
          return 'ปกติ'
        case 1:
          return 'ลงทะเบียนขอใช้สิทธินอกราชอาณาจักร'
        case 2:
          return 'ลงทะเบียนขอใช้สิทธินอกเขต'
        default:
          return ''
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.title-bg
  background-color: #373877

.center-card
  display: flex
  justify-content: center
  padding-top: 10px

.labelinfo
  text-align: left
  color: #373877

.labelmain
  font-weight: 600
</style>
